export enum MultiSelectTagKind {
    BLUE = "blue",
    GRAY = "gray",
    RED = "red",
  }
